import classNames from 'classnames';
import './styles.scss';

const Title = ({ small, children }) => {
  const titleClass = classNames({
    title: true,
    'title--small': small,
  });

  const titleWrapperClass = classNames({
    titleWrapper: true,
    'titleWrapper--small': small,
  });

  return (
    <div className={titleWrapperClass}>
      <h1 className={titleClass}>{children}</h1>
    </div>
  );
};

export default Title;
